export const homeConstants = {
  UPDATE_AVAILABLE_AREA_COUNT: "UPDATE_AVAILABLE_AREA_COUNT",
};
